import { t } from '@lingui/macro';

import { useGroupAdminStyles } from './GroupsAdminUtils';
import FormSection from '../../form/FormSection';
import ListSelectorField from '../../form/ListSelectorField';
import { GROUPS_ADMIN_DASHBOARDS_FIELD, GROUPS_ADMIN_DASHBORDS_COLUMNS } from './GroupsAdminConstants';

export function GroupsAdminDashboardsSection({ formData, setDashboardsSelectionIsDirty, dashboards }) {
    const styles = useGroupAdminStyles();

    return (
        <FormSection title={t`Dashboards`}>
            <div className={styles.selectorWrapper}>
                <ListSelectorField
                    gridColumns={GROUPS_ADMIN_DASHBORDS_COLUMNS}
                    dataArray={dashboards}
                    dataArraySearchFields={['title']}
                    dbSelected={formData?.userDashboards?.ids || []}
                    fieldName={GROUPS_ADMIN_DASHBOARDS_FIELD}
                    addButtonText={t`Add Dashboards`}
                    removeButtonText={t`Remove`}
                    setSelectionIsDirty={setDashboardsSelectionIsDirty}
                    selectedEmptyGridText={t`There are no Dashboards in this Group`}
                />
            </div>
        </FormSection>
    );
}
